import SegredoJustica from '@mui/icons-material/Lock';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../../../util/Configuracao';
import IconeOrigem from '../../../IconeOrigem';
import ReactComponent from '../../../ReactComponent';
import moment from 'moment';
import { Warning } from '@mui/icons-material';
import ModalImpressao from '@/components/shared/ModalImpressao';

class ModalPendenciasConferencia extends ReactComponent {
    /** @type {boolean} */
    carregandoInformacoesPendencias = false;

    dataGeracao = new Date();

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoInformacoesPendencias: observable,
            informacoesPendencias: computed,
            titulo: computed,
            totalDeProcessos: computed,
            totalDeProcessosPendentes: computed,
            cabecalho: computed,
            processos: computed,
            mapaProcessosPorRelator: computed
        });
    }

    get informacoesPendencias() {
        return this.processos
            .filter((processo) => processo.informacaoProcessoSalaSessao?.tipoValidacao !== 'VALIDADO')
            .map((processo) => {
                return {
                    numeroProcesso: processo.processo.numeroCompleto,
                    tipoJulgamento: processo.tipoJulgamento,
                    relator: processo.processo.relator,
                    anotacoes: processo.informacaoProcessoSalaSessao?.complementoAnotacoes
                };
            });
    }

    get titulo() {
        let titulo = 'Pendências de conferência';

        if (this.sessaoStore.sessaoSelecionada) {
            const { tipo, orgaoJudicante } = this.sessaoStore.sessaoSelecionada;
            titulo += ' - ';
            titulo += tipo === 'O' ? 'Sessão Ordinária' : 'Sessão Extraordinária';

            titulo += ' - ';
            titulo += orgaoJudicante.descricao;

            titulo += ' - ';
            titulo += moment(
                this.sessaoStore.sessaoSelecionada.prazos.dataInicioSessaoPresencial,
                'DD-MM-YYYY-HH-mm-ss'
            ).format('DD/MM/YYYY HH:mm');

            titulo += ' - ';
            titulo += this.sessaoStore.sessaoSelecionada.descricao;
        }

        return titulo;
    }

    get totalDeProcessos() {
        return 'Total de processos: ' + this.processos.length;
    }

    get totalDeProcessosPendentes() {
        return 'Total de processos pendentes: ' + this.informacoesPendencias.length;
    }

    getDataGeracao = () => {
        return 'Relatório gerado em ' + moment(this?.dataGeracao).format('DD/MM/YYYY HH:mm');
    };

    get cabecalho() {
        return (
            <Box sx={{ textAlign: 'center', mt: 1 }}>
                <Typography sx={{ justifyContent: 'center', fontWeight: 'bold' }}>{this.titulo}</Typography>
                <Typography sx={{ justifyContent: 'center' }}>{this.getDataGeracao()}</Typography>
                {
                    <Typography sx={{ justifyContent: 'center' }}>
                        {this.totalDeProcessos} / {this.totalDeProcessosPendentes}
                    </Typography>
                }
            </Box>
        );
    }

    get processos() {
        return (
            this.store.opcoesProcessosEmExibicao
                .find((opcaoProcessos) => opcaoProcessos.id === 'P')
                .funcaoProcessosFiltrados() || []
        );
    }

    get mapaProcessosPorRelator() {
        const mapaProcessoRelator = new Map();
        this.informacoesPendencias.forEach((item) => {
            if (item?.relator?.nome) {
                const identificacaoRelator = item?.relator?.genero === 'F' ? 'Relatora' : 'Relator';
                const sigla = item?.relator?.sigla ? `(${item.relator.sigla}) - ` : '';
                const chaveRelator = `${identificacaoRelator}: ${sigla}${item.relator.nome}`;
                const itensAtuais = mapaProcessoRelator.get(chaveRelator) ?? [];
                mapaProcessoRelator.set(chaveRelator, [...itensAtuais, item]);
            }
        });
        return mapaProcessoRelator;
    }

    renderTableHead() {
        return (
            <TableHead>
                <TableRow>
                    <TableCell
                        align="center"
                        sx={{ minWidth: '320px', borderTop: '1px solid rgba(224, 224, 224, 1)' }}
                    >
                        <Typography fontWeight={'bold'}>Processo</Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            border: '1px solid rgba(224, 224, 224, 1)'
                        }}
                    >
                        <Typography fontWeight={'bold'}>Votação</Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
                    >
                        <Typography fontWeight={'bold'}>Anotações</Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }

    renderTableBody(processos) {
        return (
            <TableBody>
                {processos?.map(({ numeroProcesso, tipoJulgamento, anotacoes }) => (
                    <TableRow
                        key={numeroProcesso}
                        sx={{ verticalAlign: 'top' }}
                    >
                        <TableCell
                            style={{ width: '320px' }}
                            align="left"
                        >
                            <Typography>{numeroProcesso}</Typography>
                        </TableCell>
                        <TableCell
                            style={{ width: '160px' }}
                            align="center"
                            sx={{
                                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                borderRight: '1px solid rgba(224, 224, 224, 1)'
                            }}
                        >
                            <Typography>{tipoJulgamento}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography>{anotacoes}</Typography>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        );
    }

    renderConteudo() {
        return this.processos.length === 0 || this.informacoesPendencias.length === 0 ? (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center', my: 2 }}>
                <Warning sx={{ fill: 'darkorange' }} />
                <Typography sx={{ color: 'darkorange', fontWeight: 'bold', marginLeft: '8px', marginTop: '2px' }}>
                    Nenhum processo está disponível para geração do relatório.
                </Typography>
            </Box>
        ) : (
            <>
                {Array.from(this.mapaProcessosPorRelator).map(([magistrado, processos]) => {
                    return (
                        <>
                            <Typography
                                sx={{ mt: 3, mb: 1 }}
                                fontWeight="bold"
                            >
                                {magistrado}
                            </Typography>
                            <Table
                                sx={{
                                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                    borderRight: '1px solid rgba(224, 224, 224, 1)'
                                }}
                                stickyHeader
                            >
                                {this.renderTableHead()}
                                {this.renderTableBody(processos)}
                            </Table>
                        </>
                    );
                })}
            </>
        );
    }

    renderNumeroProcesso(registro) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                }}
            >
                <Typography
                    display={'inline'}
                    sx={{ fontWeight: 'bold' }}
                >
                    {registro.processo.numeroCompleto}
                </Typography>
                {this.parametroStore.isOrgaoTST && registro.processo?.origem === Configuracao.ORIGEM_PJE && (
                    <Box sx={{ ml: 1 }}>
                        <IconeOrigem processo={registro.processo} />
                    </Box>
                )}
                {registro.segredoJustica && (
                    <Box sx={{ ml: 1 }}>
                        <Tooltip title={<Typography>SEGREDO DE JUSTIÇA</Typography>}>
                            <SegredoJustica />
                        </Tooltip>
                    </Box>
                )}
            </Box>
        );
    }

    render() {
        return (
            <ModalImpressao
                open={this.observableProps.openModalImpressao}
                onClose={this.observableProps.onCloseModalImpressao}
                titulo={this.titulo}
                cabecalho={this.cabecalho}
                carregando={this.carregandoInformacoesPendencias}
                conteudo={this.renderConteudo()}
            />
        );
    }
}

export default inject('stores')(observer(ModalPendenciasConferencia));
